import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { CrudBaseService } from '../crud.service';
import { BrgPayout, EchelonPayout, HayVnPayout, Payout, PayoutRefund, PayRetailers, RefundPayload } from '../models';
import { Observable, of } from 'rxjs';
import { omit } from 'lodash';
import { map } from 'rxjs/operators';

@Injectable()
export class PayoutService extends CrudBaseService<Payout> {
    constructor(httpClient: HttpClient) {
        super('/payout', httpClient);
    }

    javisPayout(data: Payout): Observable<Payout> {
        return this.httpClient
            .post<Payout>(`${this.basePath}/jarvis`, { data: omit(data) })
            .pipe(map((res: any) => res.data));
    }

    netellerPayout(data: Payout): Observable<Payout> {
        return this.httpClient
            .post<Payout>(`${this.basePath}/neteller`, { data: omit(data) })
            .pipe(map((res: any) => res.data));
    }

    skrillPayout(data: Payout): Observable<Payout> {
        return this.httpClient
            .post<Payout>(`${this.basePath}/skrill`, { data: omit(data) })
            .pipe(map((res: any) => res.data));
    }

    xpayPayout(data: Payout): Observable<Payout> {
        return this.httpClient
            .post<Payout>(`${this.basePath}/xpay`, { data: omit(data) })
            .pipe(map((res: any) => res.data));
    }

    rpnPayout(data: Payout): Observable<Payout> {
        return this.httpClient
            .post<Payout>(`${this.basePath}/RPNP2P`, { data: omit(data) })
            .pipe(map((res: any) => res.data));
    }

    dragonPayout(data: Payout): Observable<Payout> {
        return this.httpClient
            .post<Payout>(`${this.basePath}/philip`, { data: omit(data) })
            .pipe(map((res: any) => res.data));
    }

    echelonPayout(data: EchelonPayout): Observable<any> {
        return this.httpClient
            .post<Payout>(`${this.basePath}/echelonpay_fcs_${data.currency.toLocaleLowerCase()}`, { data: omit(data) })
            .pipe(map((res: any) => res.data));
    }

    hayVnPayout(data: HayVnPayout): Observable<any> {
        return this.httpClient
            .post<Payout>(`${this.basePath}/brg_hayvn`, { data: omit(data) })
            .pipe(map((res: any) => res.data));
    }

    refundDeposit(data: RefundPayload): Observable<any> {
        return this.httpClient
            .post<RefundPayload>(`${this.basePath}/brg_pypl/refund`, {
                data: omit(data)
            })
            .pipe(map((res: any) => res.data));
    }

    getRefundDeposit(): Observable<Array<PayoutRefund>> {
        return of([
            {
                id: 'L40049N210526023516',
                withdrawal_id: 'L801580N210519004029',
                deposit_id: 'L801590N210521075228',
                user: '4F3841F4A32411EB8ED30A6C2A10C4CE',
                amount: 11.12,
                currency: 'USD',
                status: 'CPTD',
                created_date: '2021-05-26T02:35:19',
                bridger_refund_info: {
                    response: {
                        status: 'OK',
                        code: 200,
                        message: '200'
                    },
                    result: {
                        refund_transaction_id: '8ac7a4a079ca3e6f0179ca8b6a714357',
                        amount: 48,
                        processing_date: '2021-06-02T02:26:45.6550892',
                        decline_code: '',
                        decline_reason: '',
                        status: 'approved',
                        currency: 'USD',
                        created_by: 'eightcap-payout@bridgerpay.com'
                    }
                }
            }
        ]);
    }

    payout(data: BrgPayout, gatewayId: string): Observable<any> {
        return this.httpClient
            .post<Payout>(`${this.basePath}/${gatewayId}`, { data: omit(data) })
            .pipe(map((res: any) => res.data));
    }

    payRetailersPayout(data: PayRetailers): Observable<any> {
        return this.httpClient
            .post<Payout>(`${this.basePath}/brg_fcs`, { data: omit(data) })
            .pipe(map((res: any) => res.data));
    }
}
